import { AppAreaConfig } from '@/funnels/@types'
import chairWorkoutsMale from './activity-male-chair-workouts'
import yogaFemale from './activity-female-yoga'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-yoga',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga', 'age-yoga'],
		route: {
			path: '/yoga',
			name: 'main-yoga-funnel',
		},
		overrides: [
			{
				matcher: {
					lptype: 'main_loader', // /yoga?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader', 'dynamic-age-40-80'],
			},
			{
				matcher: {
					$and: {
						utm_campaign: /search/,
						utm_content: /yoga/,
					},
				},
				ids: ['creatives-search-yoga', 'age-yoga'],
			},
		],
	},
	funnel: {
		id: 'ob-yoga-gender-selection',
		route: {
			path: '/yoga/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'yoga-survey',
		},
		slug: 'main-yoga',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: chairWorkoutsMale },
				female: { appArea: yogaFemale },
			},
		},
	},
}

export default appAreaConfig
